export default __webpack_public_path__ + "static/media/ie.80b9630a.svg";